import { useTranslation } from "react-i18next";
import { heroBanner } from "@/mocks/home";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section id="home" className="relative w-full min-h-[88vh] md:min-h-screen overflow-hidden">
      <img
        src={heroBanner}
        alt="A scene from a barewitness films production"
        title="barewitness films production still"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-accent-950/85 via-accent-950/70 to-accent-950/95"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col justify-center min-h-[88vh] md:min-h-screen pt-28 pb-20">
        <div className="max-w-3xl bw-animate">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-primary-400"></span>
            <span className="font-label text-sm uppercase tracking-[0.3em] text-primary-300">
              {t("hero.kicker")}
            </span>
          </div>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.05] text-background-50">
            {t("hero.title")}
          </h1>
          <p className="mt-6 md:mt-7 text-base md:text-lg leading-relaxed text-background-200 max-w-2xl">
            {t("hero.subtitle")}
          </p>
          <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4">
            <a
              href="#films"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-accent-950 font-label text-base uppercase tracking-[0.14em] px-7 py-3.5 rounded-md transition-colors cursor-pointer"
            >
              <i className="ri-play-circle-line text-xl"></i>
              {t("hero.ctaPrimary")}
            </a>
            <a
              href="#support"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap border border-background-50/40 hover:bg-background-50/10 text-background-50 font-label text-base uppercase tracking-[0.14em] px-7 py-3.5 rounded-md transition-colors cursor-pointer"
            >
              <i className="ri-heart-3-line text-xl"></i>
              {t("hero.ctaSecondary")}
            </a>
          </div>
        </div>

        <div className="mt-16 hidden md:flex items-center gap-3 text-background-200/80">
          <span className="w-8 h-8 flex items-center justify-center border border-background-50/30 rounded-full">
            <i className="ri-arrow-down-line animate-bounce"></i>
          </span>
          <span className="font-label text-xs uppercase tracking-[0.24em]">
            {t("hero.scroll")}
          </span>
        </div>
      </div>
    </section>
  );
}